import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import cn from "classnames";
import styles from "./styles.module.sass";
import FormControl from "react-bootstrap/FormControl";

const Select = ({
  values,
  options,
  handleChange,
  touched,
  formName,
  errors,
  label,
  placeholder,
  ariaLabel,
  className,
  disabled = false,
}) => {
  const isValid = touched[formName] && !errors[formName];
  return (
    <Form.Group
      className={styles.selectContainer}
      as={Col}
      xs="12"
      controlId="name"
    >
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Select
        aria-label={ariaLabel}
        value={values[formName] ?? ""}
        onChange={handleChange}
        name={formName}
        className={className}
        disabled={disabled}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option
            key={`option-${formName}-${option.id}-${Math.random()}`}
            value={option.id}
          >
            {option.label}
          </option>
        ))}
      </Form.Select>
      {touched[formName] && errors[formName] && (
        <>
          <div className="text-danger">{errors[formName]}</div>
        </>
      )}
    </Form.Group>
  );
};
export default Select;
